// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from './environment.model'

export const environment: Environment = {
  production: false,
  msalClientId: '7e92dd66-de8d-4d83-b680-a23799e65db0',
  msalRedirectUri: 'https://trakr-rc.embracepetinsurance.com/static/callback.html',
  msalAuthority: 'https://login.microsoftonline.com/e2f449a1-4cf6-43e3-911c-74f3ca9744f3',
  msalProtectedApiScopes: ['api://a3b92d03-2233-46fd-b111-023845fac5f6/.default'],
  apiBase: 'https://trakr-rc.embracepetinsurance.com/api',
  apiVersion: 'v1',
  crmBaseUrl: 'https://crm-rc365.embracepetinsurance.com/EmbraceCrm/',
  signalingEndpoint: 'https://signaling-service-np.salmoncliff-e7a50aba.centralus.azurecontainerapps.io',
  signalingTokenEndpoint: 'https://trakr-rc.embracepetinsurance.com/api/v1/signaling/signal-token'
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
